/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect } from "react";
import "../../CSS/general.css";
import ActionButtons from "./ActionButton";
import { AgGridReact } from "ag-grid-react";
import CompanyDropDown from "./CompanyDropDown";
import AgreementDropDown from "./AgreementDropDown";
import { API_ROUTE, Routes } from "../../Helpers/Constants";
import AuthenticationContext from "../../Store/Authentication-Context";
import Axios from "axios";
import LoaderGif from "../../images/365 loading.gif";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
const Step1 = (props) => {
    const { setAuthContext } = useContext(AuthenticationContext);
    const [disabled, setDisabled] = useState(true);
    const [uniqueAdditionLines, setUniqueAdditionLines] = useState();
    const [initialAdditionLines, setInitialAdditionLines] = useState([]);
    const renderTooltip = (props) => (

        <Tooltip id={`tooltip-${props.id}`} {...props}>
            {props.text}
        </Tooltip>

    );    const handleCellValueChanged = async (params) => {
     
       // if (params.newValue != 0)
        //{
           

            // Make the API call to update the setting on the server
            try {
                const tokenString = await setAuthContext("", new Date());
            
                const config = {
                    headers: {
                        Authorisation: `Bearer ${tokenString}`,
                        CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                    },
                };

                await Axios.patch(API_ROUTE + Routes.SET_CW_COMPANYID + '/' + params.data.orgId + '/' + params.newValue, "", config)
                    .then((response) => {
                        getCompanyAgreementForAddditionLine(false);
                    })
                    .catch((reason) => {
                        console.error("Error updating companyID:", reason);
                    });
            } catch (error) {
                console.error("Error in handleCellValueChanged:", error);
            }

      
//        }
    };

     const handleAgreementChanged = async (params) => {
     
          

            // Make the API call to update the setting on the server
            try {
                const tokenString = await setAuthContext("", new Date());
            
                const config = {
                    headers: {
                        Authorisation: `Bearer ${tokenString}`,
                        CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                    },
                };

                await Axios.patch(API_ROUTE + Routes.SET_CW_AGREEMENTID + '/' + params.data.orgId + '/' + params.newValue , "", config)
                    .then((response) => {
                        getCompanyAgreementForAddditionLine(false);
                    })
                    .catch((reason) => {
                        console.error("Error updating AgreementID:", reason);
                    });
            } catch (error) {
                console.error("Error in handleAgreementChanged:", error);
            }

      
        
    };

    const columnDefs = [
        { headerName: "Reseller", sortable: true, field: "resellerName", flex: 1 },
        { headerName: "Org Name", sortable: true, field: "orgName", flex: 1 },
        { headerName: "GoCardless ID", sortable: true, field: "goCardlessID", flex: 1 },
        {
            headerName: "CW Company ID", sortable: true, field: "cwCompanyID", editable: true, cellEditorFramework: CompanyDropDown,  cellEditorParams: {
                values: props.companies
            }, onCellValueChanged: handleCellValueChanged, flex: 1
        },
        {
            headerName: "",
            cellRenderer: (params) => (
                <button className="a-icon"
                    onClick={() =>
                        params.api.startEditingCell({
                            rowIndex: params.node.rowIndex,
                            colKey: "cwCompanyID",
                        })
                    }
                >
                    <OverlayTrigger
                        key="sort-1"
                        placement="top"
                        delay={{ show: 50, hide: 50 }}
                        overlay={(overenderTooltiprlayProps) =>
                            renderTooltip({
                                ...overenderTooltiprlayProps,
                                id: "sort-1",
                                text: "Edit Company",
                            })
                        }
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="16"
                            fill="currentColor"
                            className="bi bi-pencil-square"
                            viewBox="0 0 16 16"
                        >
                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                            <path
                                fillRule="evenodd"
                                d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                            />
                        </svg>
                    </OverlayTrigger>
                </button>
            ),
            flex: 1,
            sortable: false,
        },
        {
            headerName: "CW Agreement ID", sortable: true, field: "cwAgreementID", editable:true, cellEditorFramework: AgreementDropDown,cellEditorParams: (params) => {
                const filteredAgreements = props.agreements && props.agreements.filter(agreement => agreement.company.id === params.data.cwCompanyID);
                return {
                    values: filteredAgreements
                };
            }, onCellValueChanged: handleAgreementChanged, flex: 1
        },
        {
            headerName: "",
            cellRenderer: (params) => (
                <button className="a-icon"
                    onClick={() =>
                        params.api.startEditingCell({
                            rowIndex: params.node.rowIndex,
                            colKey: "cwAgreementID",
                        })
                    }
                >
                    <OverlayTrigger
                        key="sort-1"
                        placement="top"
                        delay={{ show: 50, hide: 50 }}
                        overlay={(overenderTooltiprlayProps) =>
                            renderTooltip({
                                ...overenderTooltiprlayProps,
                                id: "sort-1",
                                text: "Edit Aggreement",
                            })
                        }
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="16"
                            fill="currentColor"
                            className="bi bi-pencil-square"
                            viewBox="0 0 16 16"
                        >
                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                            <path
                                fillRule="evenodd"
                                d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                            />
                        </svg>
                    </OverlayTrigger>
                </button>
               
            ),
            flex: 1,
            sortable: false,
        },
    ];
    const validate = async () => {
        try {
            setDisabled(true);
            await CreateCompanies();
           
            setTimeout(() => {
                props.nextStep();
            }, 100);
           
        } catch (error) {
            console.error("Error in creating contacts or agreements:", error);
        }
    };
    async function CreateCompanies() {
        const createCompanies = [];

        // Iterate over companyContacts to prepare the contacts that need to be created
        uniqueAdditionLines.forEach((addition) => {
            if (addition.cwCompanyID === 0 && (addition.isReseller !== 0 || addition.resellerID ===1)) {
                
                const newCompany  = {
                    id: 0,
                    Identifier: addition.orgName,
                    name: addition.orgName,
                    orgId: addition.orgId,
                    OrgName: addition.orgName,
                    AdminEmail: addition.adminEmail,
                    NotificationEmail: addition.notificationEmail,
                    BillingTypeId: props.typesIds.billingTypeId,
                    NotificationTypeId: props.typesIds.notificationTypeId,
                    EffectiveDate: addition.effectiveDate,
                    GoCardlessID: addition.goCardlessID
                    }

                    

                createCompanies.push(newCompany);
            }
        });


        // Assuming you have an endpoint to create contacts in ConnectWise
        const tokenString = await setAuthContext("", new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ${tokenString}`,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };

        try {

            await Axios.post(API_ROUTE + Routes.CREATE_CONNECTWISE_COMPANY, createCompanies, config)
                .then((response) => {
                   
                    if (response && response.data) {
                       
                        props.updateAggreements(response.data);
                        return "success";
                        }
                   
                
                })
                .catch((error) => {
                    console.error("Error creating contact:", error);
                    if (error?.response?.status === 440) {
                        window.location.href = "/TimeoutErrorHandler";
                    }
                });

        } catch (error) {
            console.error("Error in CreateContacts:", error);
        }
    }

    async function getCompanyAgreementForAddditionLine(isFirstTime) {
        var tokenString = await setAuthContext("", new Date());

        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };

        await Axios.get(API_ROUTE + Routes.GET_COMPANY_AGREEMENT_FOR_ADDITION, config)
            .then((response) => {

                if (response && response.data && response.data.length>0) {
                    let responsedata = response.data;
                    if (isFirstTime && isFirstTime.toString() === 'true') {

                        responsedata = responsedata.filter(item =>
                            item.cwCompanyID === 0 || item.cwAgreementID === 0
                        );
                        setInitialAdditionLines(responsedata);
                        setUniqueAdditionLines(responsedata);
                    } 
                    else {
                        const initialOrgIds = initialAdditionLines.map(item => item.orgId);
                        const filteredData = responsedata.filter(item =>
                            initialOrgIds.includes(item.orgId)
                        );
                        setUniqueAdditionLines(filteredData);
                    }
                   
                   

                }
                setDisabled(false);

            })
            .catch((reason) => {
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }

            });
    }

    useEffect(() => {
      
    }, [props.companies,props.agreements]);
    useEffect(() => {
        getCompanyAgreementForAddditionLine(true);
    }, []);
    return (
        <div id="step1">
            <div>
                <div id="UpdatePanel1">
                    <div className="card">
                        <h4 className="card-header ">
                            <span id="TitleLabel" className="SectionTitle">Company Check</span>
                            
                        </h4>
                        <div className="card-body" style={{ borderStyle: "None", height: "400px", width: "100%" }}>
                            <div className="ag-theme-alpine ms-2" style={{ borderColor: "#F0F0F0", borderStyle: "Solid", width: "99%", height: '100%', overflowY: "auto" }}>

                                {disabled === true ?
                                    <div className="justify-content-center align-items-center d-flex h-100" style={{ minHeight: '35vh' }}>
                                        <img src={LoaderGif} alt="loading" style={{ height: '70px' }} />
                                        <span className="visually-hidden">Loading...</span>
                                    </div> :
                                    <AgGridReact
                                        columnDefs={columnDefs}
                                        rowData={uniqueAdditionLines}
                                        domLayout="normal"
                                        overlayLoadingTemplate={
                                            `<div style="position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);"><div><div style="text-align: center;"><img src="${LoaderGif}" alt="loading" style="height: 50px;"></div><span>Please wait while your rows are loading...</span></div></div>`}

                                    />
                                }

                      
                            </div>
                        </div>
                    </div>
                    <div>
                        <table cellSpacing="5" cellPadding="5" align="right">
                            <tbody>
                                <tr>
                                    <td >
                                        <ActionButtons  {...props} isDisabled={disabled} nextStep={validate} currentStep={1} totalSteps={4} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div data-act-control-type="modalPopupBackground" id="PopMsg_backgroundElement" className="Background" style={{ display: "none", position: "fixed", left: "0px", top: "0px", zIndex: "10000" }} ></div><div data-act-control-type="modalPopupBackground" id="MPE_backgroundElement" className="AnotherModalPopup" style={{ display: "none", position: "fixed", left: "0px", top: "0px", zIndex: "10000" }} ></div></div>
                {/*<HelpModal displayModal={!helpPopup} closeModal={closeModal} about="Step1-NamingaJob.html" />*/}
            </div>
        </div>
    );
}
export default Step1;